import tr from "@/locales/tr.json";
import en from "@/locales/en.json";

const LOCALES = { tr, en };
let current = "tr";

export const setLang = (lang) => {
  current = LOCALES[lang] ? lang : "tr";
};
export const getLang = () => current;

export function t(key) {
  const v = key.split(".").reduce((o, k) => (o == null ? o : o[k]), LOCALES[current]);
  return v == null ? key : v;
}
